import React from 'react';
import Reflux from 'reflux';
import {
  ColorRGBs,
  RowTypes,
  CellPaddings,
} from 'flux/stores/cuesheet/CuesheetConstants';
import HighlightCellHelper from 'main/components/show/cuesheet/highlightCellHelper';
import RTEPopover from 'shared/components/rte/rtePopover.jsx';
import classNames from 'classnames';
import CellHelper from 'main/components/show/cuesheet/cellHelper';
import { isCompact } from 'main/components/show/cuesheet/cuesheetViewHelper';
import CuesheetHelper from 'flux/helpers/cuesheetHelper';
import { DisplayTypes } from 'shared/constants/FlowConstants';
import CuesheetCursorActions from 'flux/actions/cuesheet/CuesheetCursorActions';
import ResizingTextareaActions from 'flux/actions/cuesheet/ResizingTextareaActions';
import RTEReadOnly from 'shared/components/rte/rteReadOnly';
import CuesheetTransientCellStore from 'flux/stores/cuesheet/CuesheetTransientCellStore';
import CuesheetTransientCellActions from 'flux/actions/cuesheet/CuesheetTransientCellActions';

// NOTE THIS FILE HAS MANY PROP TYPE VIOLATIONS
// AND ALL ARE DISABLED BY THE COMMENT BELOW.
/* eslint-disable react/prop-types */

const isCompactView = isCompact();

/**
 * Editable RTE Cell
 */
class EditableRTECell extends React.Component {
  constructor(props) {
    super(props);
    this._handleClick = this._handleClick.bind(this);
    this._getReadOnly = this._getReadOnly.bind(this);
    this._getMutable = this._getMutable.bind(this);
    this._handleContentChange = this._handleContentChange.bind(this);
    this._getClassNames = this._getClassNames.bind(this);
  }

  render() {
    const { isEditing, format, style, collabCell } = this.props;

    return (
      <div
        data-testid="rte-cell-readonly"
        ref={(ref) => (this._outerContainer = ref)}
        style={Object.assign(
          {},
          style,
          CellHelper.getFormatStyles(format),
          HighlightCellHelper.getCollabBackgroundStyle(collabCell),
        )}
        className={this._getClassNames()}
        onClick={this._handleClick}
      >
        {isEditing && this._getMutable()}
        {/*
           Always rendering read only version in the background so that the initial row height will be maintained (in the case of grid)
           Otherwise the row height could "collapse" initially during editing
        */}
        {this._getReadOnly()}
      </div>
    );
  }

  componentDidUpdate(prevProps) {
    const { isEditing, displayType, rowType } = this.props;
    const wasEditing = prevProps.isEditing;

    if (wasEditing || !isEditing) return;

    // We do this because the popover is not inside the table in the case of grid, so we need to set the initial height
    // of the text area/rte text area. Otherwise the initial height of the text area will not match the height of the containing
    // cell.

    const cuePadding = isCompactView
      ? CellPaddings.CompactHeader
      : CellPaddings.LooseHeader;
    const paddingOffset =
      displayType === DisplayTypes.show ? cuePadding : CellPaddings.GridHeader;
    const compactTitlePadding =
      rowType && rowType === RowTypes.TitleItem && isCompactView ? 24 : 0;

    // Subtract the cell paddings to get the inner height
    const innerContainerHeight =
      this._outerContainer.clientHeight - paddingOffset - compactTitlePadding;

    ResizingTextareaActions.setHeight(innerContainerHeight);
  }

  _getClassNames() {
    const {
      isEditing,
      isSelected,
      extraClassName,
      displayType,
      rowType,
      width,
    } = this.props;

    const gridClass =
      displayType === (DisplayTypes.schedule || DisplayTypes.list)
        ? 'rte-grid'
        : 'rte-cue';

    const titleRowClass =
      rowType === RowTypes.TitleItem ? 'cs-row-title' : null;

    return classNames(
      extraClassName,
      'cs-cell',
      gridClass,
      titleRowClass,
      {
        'cs-cell-editing': isEditing,
        'cs-cell-selected': isSelected,
      },
      CuesheetHelper.getColumnWidthClass(width),
    );
  }

  _getReadOnly() {
    const { corrupted, rteState, placeholder, collabCell } = this.props;

    return (
      <RTEReadOnly
        collabCell={collabCell}
        customColors={ColorRGBs}
        rteState={rteState}
        corrupted={corrupted}
        placeholder={placeholder}
      />
    );
  }

  _getMutable() {
    const { keyPrefix, height, rteState, partialCell, isEditing, rowId } =
      this.props;

    return (
      <MutableRTEPopover
        {...{
          keyPrefix,
          height,
          rteState,
          partialCell,
          isEditing,
          rowId,
        }}
        classNames={this._getClassNames()}
        onContentChange={this._handleContentChange}
      />
    );
  }

  _handleClick() {
    const {
      isEditing,
      isSelected,
      onSelect,
      onStartEdit,
      corrupted,
    } = this.props;

    if (!isEditing && !isSelected && onSelect) {
      onSelect();
    } else if (isSelected && !isEditing) {
      //Prevent user from going into edit mode of corrupted cells.
      if (!corrupted) onStartEdit();
    }
  }

  _handleContentChange(content, rowId) {
    CuesheetTransientCellActions.clearTransientCellValue();
    const { onStopEdit } = this.props;
    onStopEdit(content, rowId);
  }
}

EditableRTECell.defaultProps = {
  resizeWhenEditing: true,
  placeholder: '',
};

EditableRTECell.propTypes = {
  isEditing: React.PropTypes.bool,
  isSelected: React.PropTypes.bool,
  extraClassName: React.PropTypes.string,
  onSelect: React.PropTypes.func.isRequired,
  onStartEdit: React.PropTypes.func.isRequired,
  onStopEdit: React.PropTypes.func.isRequired,
  resizeWhenEditing: React.PropTypes.bool,
  rteState: React.PropTypes.oneOfType([
    React.PropTypes.object,
    React.PropTypes.string,
  ]),
  format: React.PropTypes.object,
  placeholder: React.PropTypes.string,
};

const MutableRTEPopover = React.createClass({
  mixins: [Reflux.connect(CuesheetTransientCellStore, 'transientRteState')],

  render() {
    const {
      classNames,
      isEditing,
      rteState,
      keyPrefix,
      height,
      partialCell,
      onContentChange,
      rowId,
    } = this.props;
    return (
      <RTEPopover
        isEditing={isEditing}
        onKeyDown={() => CuesheetCursorActions.moveCursorDown(true)}
        onTab={(e) => {
          e.preventDefault();
          e.stopPropagation();

          if (e.shiftKey) {
            CuesheetCursorActions.moveCursorLeft(true);
          } else {
            CuesheetCursorActions.moveCursorRight();
          }

          return true;
        }}
        displayToolbar
        toolbarOnFocus={false}
        autoFocus
        rteState={this.state.transientRteState || rteState}
        id={keyPrefix}
        minHeight={height}
        partialCell={partialCell}
        editorClassName={classNames}
        displayNode={<div className="rte-editor-display" />}
        onContentChange={onContentChange}
        onExternalContentChange={(rteState) => {
          CuesheetTransientCellActions.setTransientCellValue(rteState);
        }}
        rowId={rowId}
      />
    );
  },
});

export default EditableRTECell;
